import { Lookup } from "./lookup.model";
import { GroupLedger } from "./groupledger.model";
import { EntityBase } from "./entity-base.model";
export class GeneralLedger extends EntityBase {
  public Code: number;
  public Title: string;
  public GroupLedgerId: number;
  public GroupLedgerKindId: number;
  public Comment: string;
  public GroupLedgerKind: Lookup;
  public GroupLedgerKindTitle: string;
  public GroupLedgerKindCode?: number;
  public GroupLedger: GroupLedger;
  public GroupLedgerCode?: number;
  public GroupLedgerTitle: string;
  public ForecastBudgetMinPercent?: number;
  public ForecastBudgetMaxPercent?: number;
  public ProfiteLossKindId?: number;
  public ProfiteLossKind?: Lookup;
  public ProfiteLossKindTitle?: string;
  public ProfiteLossKindCode?: number;
}
